<template>
  <div class="wrap" :class="classes" @click.self="onClose">
    <div class="container">
      <slot name="header">
        <div class="no-header" />
      </slot>

      <div class="content">
        <slot name="close" />

        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue-demi'
import { isString } from '@svoi-ui/shared/utils/guards'
import { ModalSizes } from '@svoi-ui/interfaces/modal'

export default defineComponent({
  name: 'SvoiModalContent',
  props: {
    size: {
      type: String as PropType<ModalSizes>,
      default: ModalSizes.md,
      validator: (value: unknown) => {
        return (
          isString(value) &&
          [
            ModalSizes.full.toString(),
            ModalSizes.md.toString(),
            ModalSizes.sm.toString(),
            ModalSizes.lg.toString()
          ].includes(value)
        )
      }
    }
  },
  emits: ['out-click'],
  setup(props, { emit }) {
    const classes = computed(() => ({
      [`-size-${props.size}`]: true
    }))

    const onClose = () => {
      emit('out-click')
    }

    return { onClose, classes }
  }
})
</script>

<style lang="scss" scoped>
@use '@svoi-ui/assets/scss/components/modal/modal-content';
</style>
